/* Stooner — buscador de la lupa con «Lo más buscado» y «Productos recomendados» (formato Scuffers, 4 nov 2026).
   - Al abrirse (body.show-search) mide dónde acaba la cabecera para que el panel empiece justo debajo
     (--search-top) y pide una sola vez los recomendados a sections/search-recommended.liquid.
   - La lupa de la cabecera hace de X: con el buscador abierto, lo cierra. Tocar otro control de la
     cabecera (menú, guardados, carrito…) también lo cierra antes de seguir.
   - Las pastillas escriben la búsqueda en el campo y lanzan la búsqueda del tema (evento change).
   - «Borrar» dentro del campo y la fila «Resultados · Ver todos» encima de los resultados. */
(function () {
  if (window.stoonerSearchDiscovery) return;
  window.stoonerSearchDiscovery = true;

  var body = document.body;

  function panel() {
    return document.querySelector('.section-header main-search');
  }

  function isOpen() {
    return body.classList.contains('show-search');
  }

  function closeSearch() {
    body.classList.remove('show-search');
  }

  // El panel empieza donde acaba la cabecera (con la fila del menú en el ordenador y la pastilla en el móvil)
  function placePanel() {
    var ms = panel();
    var header = document.querySelector('.section-header');
    if (!ms || !header) return;
    ms.style.setProperty('--search-top', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
  }

  // Marca de guardado en tarjetas que llegan después de pintarse la lista de deseos
  function paintWishlist(container) {
    if (!window.StoonerWishlist) return;
    container.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = window.StoonerWishlist.has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function loadRecommended() {
    var ms = panel();
    var block = ms && ms.querySelector('[data-search-reco]');
    if (!block || block.dataset.state) return;
    block.dataset.state = 'loading';

    fetch(block.dataset.searchReco)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = block.querySelector('[data-search-reco-grid]');
        var cards = doc.querySelectorAll('.search-recommended product-block');

        // Igual que hace main-search.js con los resultados: sin el botón de compra rápida del tema
        cards.forEach(function (card) {
          card.querySelectorAll('.btn.quickbuy-toggle').forEach(function (el) { el.remove(); });
          card.querySelectorAll('.quickbuy-toggle').forEach(function (el) { el.classList.remove('quickbuy-toggle'); });
          grid.appendChild(document.adoptNode(card));
        });

        paintWishlist(grid);
        block.hidden = cards.length === 0;
        block.dataset.state = 'done';
      })
      .catch(function () {
        block.dataset.state = '';
      });
  }

  function syncLinks(open) {
    var ms = panel();
    document.querySelectorAll('.section-header .show-search-link').forEach(function (link) {
      if (!link.dataset.labelOpen) link.dataset.labelOpen = link.getAttribute('aria-label') || '';
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && ms && ms.dataset.labelClose) {
        link.setAttribute('aria-label', ms.dataset.labelClose);
      } else if (link.dataset.labelOpen) {
        link.setAttribute('aria-label', link.dataset.labelOpen);
      } else {
        link.removeAttribute('aria-label');
      }
    });
  }

  function updateClear(ms) {
    var input = ms && ms.querySelector('.main-search__input');
    var clear = ms && ms.querySelector('.main-search__clear');
    if (input && clear) clear.hidden = !input.value;
  }

  function runSearch(ms, value) {
    var input = ms.querySelector('.main-search__input');
    input.value = value;
    input.dispatchEvent(new Event('change'));
    updateClear(ms);
  }

  // Fila «Resultados · Ver todos» encima de los resultados (el botón del tema se queda abajo)
  function decorateResults(ms) {
    var box = ms.querySelector('.main-search__results');
    var allLink = box && box.querySelector('.main-search__results-all-link');
    if (!allLink || box.querySelector('.search-results-head')) return;

    var head = document.createElement('div');
    head.className = 'search-results-head';
    var label = document.createElement('span');
    label.textContent = ms.dataset.labelResults || '';
    var link = document.createElement('a');
    link.href = allLink.href;
    link.textContent = ms.dataset.labelViewAll || allLink.textContent;
    head.appendChild(label);
    head.appendChild(link);
    box.insertBefore(head, box.firstChild);
    paintWishlist(box);
  }

  function init() {
    var ms = panel();
    if (!ms || ms.dataset.discoveryReady) return;
    ms.dataset.discoveryReady = 'true';

    var box = ms.querySelector('.main-search__results');
    if (box) {
      new MutationObserver(function () { decorateResults(ms); }).observe(box, { childList: true });
    }
    updateClear(ms);
  }

  // Con el buscador abierto, la lupa de la cabecera cierra; cualquier otro control de la cabecera lo cierra y sigue
  document.addEventListener('click', function (evt) {
    if (!isOpen()) return;
    var link = evt.target.closest('.section-header .show-search-link');
    if (link) {
      evt.preventDefault();
      evt.stopPropagation();
      closeSearch();
      return;
    }
    if (evt.target.closest('.section-header .pageheader a, .section-header .pageheader button, .section-header main-navigation a')) {
      closeSearch();
    }
  }, true);

  document.addEventListener('click', function (evt) {
    var pill = evt.target.closest('.search-discovery__pill');
    if (pill) {
      var ms = pill.closest('main-search');
      runSearch(ms, pill.dataset.searchTerm || pill.textContent.trim());
      ms.scrollTop = 0;
      return;
    }

    var clear = evt.target.closest('.main-search__clear');
    if (clear) {
      var msClear = clear.closest('main-search');
      runSearch(msClear, '');
      msClear.querySelector('.main-search__input').focus();
    }
  });

  document.addEventListener('input', function (evt) {
    if (evt.target.matches && evt.target.matches('.main-search__input')) {
      updateClear(evt.target.closest('main-search'));
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && isOpen()) closeSearch();
  });

  // Se piden los recomendados en cuanto se apunta a la lupa, para que estén al abrir
  ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (evt) {
      if (evt.target.closest && evt.target.closest('.section-header .show-search-link')) loadRecommended();
    }, { passive: true });
  });

  var wasOpen = false;
  new MutationObserver(function () {
    var open = isOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    syncLinks(open);
    if (open) {
      init();
      placePanel();
      loadRecommended();
    }
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('resize', function () {
    if (isOpen()) placePanel();
  });

  document.addEventListener('shopify:section:load', init);
  init();
})();
